import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ css }) => {
  return {
    stepsList: css`
      max-height: calc(100vh - 250px);
      overflow-y: auto;
    `
  }
})
